import { render, staticRenderFns } from "./Apikey.vue?vue&type=template&id=2252680a&scoped=true&"
import script from "./Apikey.vue?vue&type=script&lang=js&"
export * from "./Apikey.vue?vue&type=script&lang=js&"
import style0 from "./Apikey.vue?vue&type=style&index=0&id=2252680a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2252680a",
  null
  
)

export default component.exports